import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import TrackingEvents from 'Services/Tracker/TrackingEvents'
import Payment from '../Payment'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import States from 'Components/Elements/Forms/StatesModal/Country/AustraliaStates.json'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import KuwaitAddressData from 'Configs/Address/Kuwait/KuwaitAddressData.json'

class Kuwait {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    shippingMethod = 'delivery'
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip_code'
    }

    chainAddress = {
        isChainAddress: false,
        groupAddress: ['city_selection', 'area_selection']
    }

    uuid = ''

    paymentMethod = ''

    addressListOptions = []

    selectedCity = ''
    selectedArea = ''

    dialCode = '+965'

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password: ''
            // password1: '',
            // password2: ''
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: ''
        },
        shop: {
            uuid: this.GetUuid(),
            firstname_en: '',
            lastname_en: '',
            email: '',
            phone: '',
            // address: '',
            flat_villa: '', // เปลี่ยนเป็น address1
            building_name: '',
            city: '',
            area: '',
            email: ''
            // shipment_options: 'delivery'
        }
    }

    formShop = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        password: '',
        address: '',
        building_name: '',
        city: '',
        area: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        address: '',
        address2: '',
        city: '',
        area: '',
        period: ''
    }

    ExcludedFieldsShippingIfCreateAccount = ['fullName']

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        firstname: 'firstname_en',
        lastname: 'lastname_en',
        city_selection: 'city',
        area_selection: 'area',
        address1: 'address'
    }

    ArrangeCreateCheckoutForm = ['firstname', 'lastname', 'email', 'password', 'phone', 'country', 'flat_villa', 'building_name', 'address1', 'address2', 'city_selection', 'area_selection']

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        // {
        //     caption: 'billing',
        //     link: '/checkout/payment',
        //     paramsRequire: true
        // },
        {
            caption: 'purchase',
            link: '/checkout/payment',
            paramsRequire: true
        }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'standard_delivery',
            dict_key: '',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'creditCard',
                    dict_key: 'creditcard',
                    for_status: [],
                    value: 'creditCard',
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: ''
                },
                // Apple Pay temporarily disabled for Kuwait. Uncomment to restore.
                // {
                //     id: 2,
                //     title: 'applePay',
                //     dict_key: 'applePay',
                //     for_status: [],
                //     value: 'applePay',
                //     descripion: {
                //         title: '',
                //         dict_key: ''
                //     },
                //     icon: ''
                // },
                {
                    id: 3,
                    title: 'knet',
                    dict_key: 'knet',
                    for_status: [],
                    value: 'knet',
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: ''
                }
                // {
                //     id: 1,
                //     title: 'Myfatoorah',
                //     dict_key: 'myfatoorah',
                //     for_status: [],
                //     value: 'myfatoorah',
                //     descripion: {
                //         title: '',
                //         dict_key: ''
                //     },
                //     icon: 'creditcard-icon'
                // },
                // {
                //     id: 2,
                //     title: 'Bank wire',
                //     dict_key: 'bankwire',
                //     for_status: [],
                //     value: 'bankwire',
                //     descripion: {
                //         title: '',
                //         dict_key: ''
                //     },
                //     icon: 'creditcard-icon'
                // }
            ]
        }
    ]

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping'
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: true,
            allowToUse: []
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    StatesList() {
        let items = []
        KuwaitAddressData.map(raw => {
            items.push({
                text: raw.city_name_english,
                value: raw.city_name_english,
                html: `<span>${raw.city_name_english}</span>`
            })
        })
        return items
    }

    AddressOptionList(key, fn) {
        const addressData = this.GetAddressListOptions()

        let items = { city: [], area: [] }
        addressData.map(raw => {
            items.city.push({
                text: raw.city_name_english,
                value: raw.city_name_english,
                html: `<span>${raw.city_name_english}</span>`
            })
        })

        const cityValue = get(
            (fn.GetCheckoutForms() || []).find(item => item.key === 'city_selection'),
            'value'
        ) // 'Kuwaut city'

        if (cityValue) {
            const filteredCities = KuwaitAddressData.find(item => item.city_name_english === cityValue)
            filteredCities.areas.map(item => {
                items.area.push({
                    text: item.area_name_english,
                    value: item.area_name_english,
                    html: `<span>${item.area_name_english}</span>`
                })
            })
        }

        return key === 'city_selection' ? items.city : items.area
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    GetDialCode() {
        return this.dialCode
    }

    SetDialCode(value) {
        this.dialCode = value
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    // GetShippingMethod() {
    //     return this.shippingMethods
    // }

    GetShippingMethod() {
        return this.shippingMethods.find(item => item.api_value === this.shippingMethod)
    }

    GetShippingMethods() {
        return this.shippingMethods
    }

    SetPaymentMethod(value) {
        runInAction(() => {
            this.paymentMethod = value
        })
    }

    GetPaymentMethod() {
        return this.paymentMethod
    }

    SomeCustomFormSelector = formItem => {
        switch (formItem.key) {
            case 'city_selection':
                // formItem.placeholder = '' // uncomment when city field is not selection
                // formItem.type = 'text' // uncomment when city field is not selection
                break
            case 'area_selection':
                // formItem.placeholder = '' // uncomment when area field is not selection
                // formItem.type = 'text' // uncomment when area field is not selection
                break
            default:
                break
        }
        return formItem
    }

    SetAddressListOptions(value) {
        runInAction(() => {
            this.addressListOptions = value
        })
    }

    GetAddressListOptions() {
        return this.addressListOptions
    }

    // City ID methods
    // Selected City methods
    GetSelectedCity() {
        return this.selectedCity
    }

    SetSelectedCity(value) {
        runInAction(() => {
            // Clear area when city changes
            if (value !== this.selectedCity) {
                this.SetSelectedArea('')
            }
            this.selectedCity = value
        })
    }

    // Selected Area methods
    GetSelectedArea() {
        return this.selectedArea
    }

    SetSelectedArea(value) {
        runInAction(() => {
            this.selectedArea = value
        })
    }

    // Get list of cities (from API only)
    GetCityList() {
        const addressData = this.GetAddressListOptions()
        if (!addressData || addressData.length === 0) return []
        
        return addressData.map(city => ({
            city_name_english: city.city_name_english,
            city_name_native: city.city_name_native || city.city_name_english,
        }))
    }

    // Get list of areas for selected city (from API only)
    GetAreaList() {
        if (!this.selectedCity) return []
        
        const addressData = this.GetAddressListOptions()
        if (!addressData || addressData.length === 0) return []
        
        const cityData = addressData.find(city => city.city_name_english === this.selectedCity)
        if (!cityData || !cityData.areas) return []
        
        return cityData.areas.map(area => ({
            area_name_english: area.area_name_english,
            area_name_native: area.area_name_native || area.area_name_english,
        }))
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, products) {
        const Pay = new Payment(uuid, detailPage)
        try {
            const responsePreparePayment = await Pay.PreparePaymentData()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            Pay.hydra.transactions = {
                items: [
                    {
                        amount: 'this.terms.total',
                        type: 'IOU',
                        method: 'BankWire',
                        billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                        billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                        billToAddress: {
                            country: StoreCountry.Country2()
                        }
                    }
                ]
            }

            await Pay.PostToHydra()

            Pay.SendEmailV4()
            Pay.SendSms()

            await Pay.UpdateToLog(Pay.hydra.transactions)

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            try {
                TrackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'KWD',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            Pay.UpdateToLog(Pay.hydra.transactions, 0, true)
            return { success: false }
        }
    }

    async SubmitPaymentWithApplePay(uuid, detailPage, CreditCardEncrypted, billingAddressForm, products, options, type, CreditCardAlias, applePayResult, customerHref = '') {
        const Pay = new Payment(uuid, detailPage)

        try {
            const responsePreparePayment = await Pay.PreparePaymentData()
            const allowCreditEnable = StoreAuth.IsAllowCredit()
            let applePayTransaction = {}

            if (applePayResult) {
                applePayTransaction = {
                    amount: 'this.terms.total',
                    type: 'IOU',
                    method: 'CreditCard',
                    billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                    billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                    billToAddress: {
                        country: StoreCountry.Country2()
                    },
                    methodDetails: {
                        encryptedApplePayPayment: applePayResult,
                        bankName: 'WorldPay-ApplePay'
                    }
                }
            }
            
            if (CreditCardAlias && CreditCardAlias.length > 0) {
                const creditCardAliasData = {
                    type: 'AuthorizeAndCapture',
                    method: 'CreditCardAlias',
                    methodDetails: {
                        alias: CreditCardAlias
                    },
                    amount: 'this.terms.total'
                }

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    let amount = Number(Pay.ushop.total_price) - Number(storeCredit.ProductCreditUsed().amount)
                    if (amount > 0) {
                        creditCardAliasData.amount = Number(amount)
                        Pay.hydra.transactions = { items: [creditCardAliasData, storeCredit.ProductCreditUsed()] }
                    } else {
                        Pay.hydra.transactions = { items: [storeCredit.ProductCreditUsed()] }
                    }
                } else {
                    Pay.hydra.transactions = { items: [creditCardAliasData] }
                }
            } else {
                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    let amount = Number(Pay.ushop.total_price) - Number(storeCredit.ProductCreditUsed().amount)
                    if (amount > 0) {
                        applePayTransaction.amount = Number(amount)
                        Pay.hydra.transactions = { items: [applePayTransaction, storeCredit.ProductCreditUsed()] }
                    } else {
                        Pay.hydra.transactions = { items: [storeCredit.ProductCreditUsed()] }
                    }
                } else {
                    console.log('applePayTransaction', applePayTransaction)
                    if (applePayTransaction) {
                        Pay.hydra.transactions = { items: [applePayTransaction] }
                    }
                }
            }

            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)

            if (hasSubscribe) {
                await Pay.PostToHydraWithCreateAutoShip()
            } else {
                await Pay.PostToHydra()
            }

            Pay.SendEmailV4()
            Pay.SendSms()

            if (hasSubscribe) {
                await Pay.UpdateToLog(Pay.hydra.transactions, 1, false, 'success')
            } else {
                await Pay.UpdateToLog(Pay.hydra.transactions, 0, false, 'success')
            }

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                TrackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'KWD',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}

            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            const periodResponse = await FeelGreatAPI.GetPeriod('KW')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            forms.country_calling_code = this.GetDialCode().replace('+', '')

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                emailDelay: ServerEnv.ENV === 'DEV' ? undefined : '1h',
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined
            })

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/KWT/feelGreat/createAccount${queryStrings}`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    pageConfig = {
        signUp: {
            disable: true
        }
    }

    GetPageConfig() {
        return this.pageConfig
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        makeAutoObservable(this)
    }
}

export default Kuwait
